import type { ISearchBarResources } from "./SearchBar.Resources";

export const SearchBarResourcesEn: ISearchBarResources = {
    searchWatermark: "Search in goodie",
    noResults: "No results for this search",
    searchHistory: "Search history",
    searchTitle: "Suggestions",
    searchPopularTitle: "Popular Phrases",
};
